<div class="d-flex justify-content-center align-items-center p-5">
  <div class="bg-white shadow rounded p-4 w-100">
  <h3 class="mb-4">{{ translationService.getTranslation('Exam Preparation') }}</h3>
  <br>
    <div class="row mb-4">
      <div class="col-12">
        <label for="trainee-id">{{ translationService.getTranslation('Enter Candidate ID') }}</label>
      </div>

      <div class="col-md-3">
        <select class="form-control" [(ngModel)]="selectedCandidateID" (change)="getSelectedCandidateID()">
          <option value="">{{ translationService.getTranslation('Candidates for Today') }}</option>
          <option *ngFor="let trainee of candidateForToday" [value]="trainee.nid">
            {{ trainee.nid }}
          </option>
        </select>
      </div>

      <div class="col-md-5">
        <input type="text" id="trainee-id" class="form-control" [(ngModel)]="identification" autocomplete="off">
      </div>

      <div class="col-md-2">
        <button class="btn btn-success w-100" [disabled]="identification.length < 9" (click)="getTraineeDetails()">
          {{ translationService.getTranslation('Inquiry') }}
        </button>
      </div>

      <div class="col-12">
        <span *ngIf="showAlert" class="text-danger mt-2 d-block">{{ errorMessage }}</span>
      </div>
    </div>


  <div class="card mb-4">
    <div class="card-body">
      <h3>{{ translationService.getTranslation('Candidate Details') }}</h3>
      <table class="table table-bordered table-striped">
        <thead class="table-success">
          <tr>
            <th>{{ translationService.getTranslation('Course Name') }}</th>
            <th>{{ translationService.getTranslation('Language') }}</th>
            <th>{{ translationService.getTranslation('Book Type') }}</th>
            <th>{{ translationService.getTranslation('Status') }}</th>
            <th>{{ translationService.getTranslation('Exam Date') }}</th>
            <th>{{ translationService.getTranslation('ID Number') }}</th>
            <th>{{ translationService.getTranslation('Candidate Name') }}</th>
            <th>{{ translationService.getTranslation('Phone Number') }}</th>
            <th>{{ translationService.getTranslation('Gender') }}</th>
            <th>{{ translationService.getTranslation('Exam Attendance Number') }}</th>
          </tr>          
        </thead>
        <tbody>
          <tr *ngIf="traineeInfo">
            <td>{{ traineeInfo?.courseName }}</td>
            <td>{{ traineeInfo?.courseLang }}</td>
            <td>{{ traineeInfo?.bookingType }}</td>
            <td>{{ traineeInfo?.traineeExamStatus }}</td>
            <td>{{ traineeInfo?.sessionDate | date }}</td>
            <td>{{ traineeInfo?.traineeID }}</td>
            <td>{{ traineeInfo?.traineeName }}</td>
            <td>{{ traineeInfo?.phone }}</td>
            <td>{{ traineeInfo?.gender }}</td>
            <td>{{ traineeInfo?.examAttendanceNumber || examAttendanceNumber}}</td>          
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row mb-4 text-center justify-content-center">
    <div class="col-md-3">
      <button class="btn btn-success w-100 mb-2" 
        [disabled]="isInquiry || !!(traineeInfo?.examAttendanceNumber || examAttendanceNumber)"
        (click)="generateAttendanceNumber()">
        {{ translationService.getTranslation('Generate Exam Attendance Number') }}
      </button>
    </div>

    <div class="col-md-3">
      <button class="btn btn-warning w-100 mb-2" 
        [disabled]="!isSendSMS || (!traineeInfo?.examAttendanceNumber && !examAttendanceNumber)" 
        (click)="sendSMS()">
        {{ translationService.getTranslation('Send SMS') }}
      </button>
    </div>

    <div class="col-md-3">
      <button class="btn btn-primary w-100 mb-2" 
        [disabled]="!traineeInfo?.examAttendanceNumber && !examAttendanceNumber" 
        (click)="printExamNumber()">
        {{ translationService.getTranslation('Print Exam Attendance Number') }}
      </button>
    </div>

    <div class="col-12">
      <h4 *ngIf="successMessage" class="text-success mt-2">{{ errorMessage }}</h4>
    </div>
  </div>
    
  <div class="form-group my-4">
    <h4>{{ translationService.getTranslation('Exam Attendance Number') }}</h4>
    <div class="form-control bg-light border fw-bold text-center" style="font-size: 1.5rem;">{{ traineeInfo.examAttendanceNumber || examAttendanceNumber || '-' }}</div>
</div>
</div>


<div #printSection style="display: none">
  <div style="text-align: center;">
    <img src="https://exam.alarkkan.app/assets/logo/momma.png" alt="Logo" class="img-fluid mx-auto d-block" style="max-width: 80%; height: auto; margin-bottom: 80px;" />
    <h1>Print Exam Attendance Number - طباعة رقم حضور الاختبار</h1>
    <h2>{{ currentUser }} <strong>طُبع بواسطة</strong></h2>
    <h2>{{ currentDate | date: 'yyyy-MM-dd - h:mm a' }}   <strong>تاريخ الطباعة</strong></h2>
  </div>
  <h2 style="text-align: center; margin-top: 55px;">Candidate Details - تفاصيل المرشح</h2>
  <table class="table table-bordered table-striped">
    <thead class="table-success">
      <tr>
        <th>{{ translationService.getTranslation('Gender') }}</th>
        <th>{{ translationService.getTranslation('Phone Number') }}</th>
        <th>{{ translationService.getTranslation('Candidate Name') }}</th>
        <th>{{ translationService.getTranslation('ID Number') }}</th>
        <th>{{ translationService.getTranslation('Exam Date') }}</th>
        <th>{{ translationService.getTranslation('Status') }}</th>
        <th>{{ translationService.getTranslation('Book Type') }}</th>
        <th>{{ translationService.getTranslation('Language') }}</th>
        <th>{{ translationService.getTranslation('Course Name') }}</th>
      </tr>          
    </thead>
    <tbody>
      <tr *ngIf="traineeInfo">
        <td>{{ traineeInfo?.gender }}</td>
        <td>{{ traineeInfo?.phone }}</td>
        <td>{{ traineeInfo?.traineeName }}</td>
        <td>{{ traineeInfo?.traineeID }}</td>
        <td>{{ traineeInfo?.sessionDate | date }}</td>
        <td>{{ traineeInfo?.traineeExamStatus }}</td>
        <td>{{ traineeInfo?.bookingType }}</td>
        <td>{{ traineeInfo?.courseLang }}</td>
        <td>{{ traineeInfo?.courseName }}</td>
      </tr>
    </tbody>
  </table>
  <h2 style="margin-top: 50px; text-align: center; letter-spacing: 2px;">{{traineeInfo.examAttendanceNumber || examAttendanceNumber}}</h2>
</div>

